import React from "react";

const ButtonOutlineFluid = ({ onClick, id, name, label }) => {
  return (
    <button
      id={id}
      name={name}
      onClick={onClick}
      className="w-full font-lato text-center  border-2 border-solid bg-white transition-all text-secondary-color active:bg-[#043b48] active:border-[#043b48] hover:text-white ease-in-out duration-200 hover:bg-secondary-color border-secondary-color rounded-[0.675rem] p-[0.675rem]"
    >
      {label}
    </button>
  );
};

export default ButtonOutlineFluid;
